<template>
  <f7-page name="recommendfriendHistory">
    <bc-navbar></bc-navbar>
    <div class="page_single layout_fullwidth_padding">
      <page-header :title="title" :backUrl="backLink">
        <template v-slot:headerIcon>
          <img src="/static/svg/referral.svg" alt="referral icon" />
        </template>
      </page-header>
      <p class="description">
       {{disclaimer}}
      </p>
      <section>
        <features :referralProgramType="referralProgramType"/>
      </section>
      <section class="steps">
        <div class="step" v-for="(step, index) in steps" :key="index">
          <h3>{{ index + 1 }}. {{ step.title }}</h3>
          <p>{{ step.description }}</p>
        </div>
      </section>

      <section class="links">
        <a class="link" :href="termsLink">Terms and Conditions</a>
        <a class="link" :href="policyLink">Privacy Policy</a>
      </section>
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { PAGES } from '../../shared/routes.constants'
import FeaturesComponent from '@components/referral/how-it-works-features.vue'
export default {
  name: 'how-it-works',
  components: {
    features: FeaturesComponent
  },
  computed: {
    ...mapGetters({
      disclaimer: 'recommendFriend/disclaimer',
      steps: 'recommendFriend/steps',
      referralProgramType: 'recommendFriend/referralProgramType'
    })
  },
  mounted: async function () {
    await this.getInfo()
  },
  methods: {
    ...mapActions({
      getInfo: 'recommendFriend/getInfo'
    })
  },
  data () {
    return {
      title: 'How does it work?',
      backLink: PAGES.RacommendAFriend,
      termsLink: PAGES.TermAndConditions,
      policyLink: PAGES.PrivacyPolicy
    }
  }
}
</script>

<style scoped>
.steps,
.links {
  display: grid;
}

.steps {
  gap: 32px;
  margin-bottom: 32px;
}

.links {
  gap: 15px;
}

.link{
    font-size: 16px;
    font-weight: 600;
    color: rgba(44, 97, 213, 1);
}

.step > h3 {
  font-weight: 600;
  padding: 0;
  margin-bottom: 15px;
}

.step > p {
  margin: 0;
}

.page_single{
    padding-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// how-it-works.vue?51b46bad